import { Rating } from "../api/Items";
import FlagOutlineIcon from "./icons/FlagOutlineIcon";
import { getColorCode } from "../reports/utils";
import { behaviorMap, useFamaFlags } from "../api/FamaFlags";

const convertColor = (name: string) => {
  return getColorCode(name) || "grey";
};

function RatingBadges({
  ratings,
  showFlagIcon,
}: {
  ratings: Rating[];
  showFlagIcon?: boolean;
}): JSX.Element {
  const { behaviorMappingActions } = useFamaFlags();
  return (
    <>
      <span className="inline-flex items-center">
        {showFlagIcon && (
          <span className="self-start pr-4">
            <FlagOutlineIcon />
          </span>
        )}
        <div className="flex flex-wrap gap-2">
          {ratings.map((rating) => (
            <span
              key={rating.external_id}
              style={{
                background: `${convertColor(rating.name)}33`,
              }}
              className="inline-flex items-center py-1 px-3 rounded-md text-black-800 text-xs font-light"
            >
              <span className="capitalize">
                {behaviorMap(rating.name, behaviorMappingActions, "key")}
              </span>
            </span>
          ))}
        </div>
      </span>
    </>
  );
}

export default RatingBadges;
